import { ViewportScroller } from '@angular/common';
import { Component, signal } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

import { QuoteStateService } from '../../services/quote-state.service';

@Component({
  selector: 'app-hero',
  imports: [FormsModule, MatIconModule, TranslateModule],
  templateUrl: './hero.component.html',
  styleUrl: './hero.component.scss',
})
export class Hero {
  origin = signal('');
  destination = signal('');
  weight = signal('');
  loadType = signal('');

  constructor(
    private readonly quoteState: QuoteStateService,
    private readonly viewportScroller: ViewportScroller
  ) {}

  get originValue(): string {
    return this.origin();
  }

  set originValue(value: string) {
    this.origin.set(value);
  }

  get destinationValue(): string {
    return this.destination();
  }

  set destinationValue(value: string) {
    this.destination.set(value);
  }

  get weightValue(): string {
    return this.weight();
  }

  set weightValue(value: string) {
    this.weight.set(value);
  }

  get loadTypeValue(): string {
    return this.loadType();
  }

  set loadTypeValue(value: string) {
    this.loadType.set(value);
  }

  onGetBestRate(): void {
    this.quoteState.setQuickRate({
      origin: this.origin(),
      destination: this.destination(),
      weight: this.weight(),
      loadType: this.loadType(),
    });
    this.viewportScroller.scrollToAnchor('quote');
  }
}
